<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
	<el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
		<!--			<el-form-item style="margin-bottom:0;" class="filter-item">-->
<!--				<el-input v-model="filters.label" placeholder="名称"></el-input>-->
<!--			</el-form-item>-->
<!--			<el-form-item style="margin-bottom:0;" class="filter-item">-->
<!--				<kt-button :label="$t('action.search')" perms="sys:tAfoWaveDetail:view" type="primary" @click="findPage(null)"/>-->
<!--			</el-form-item>-->
			<el-form-item style="margin-bottom:0;" class="filter-item">
				<kt-button :label="$t('action.addOrder')" perms="sys:tWaveMaster:add" type="primary" @click="handleAdd" />
			</el-form-item>
		</el-form></div>
		</div>
	<!--表格内容栏-->
	<kt-table permsEdit="sys:tWaveMaster:edit" permsDelete="sys:tWaveMaster:delete" permsView="sys:tWaveMaster:view" :displayOperation1Button="true" :displayButtonEdit="false"
		:data="pageResult" :columns="columns" :buttonEdit="$t('action.edit')" :buttonDelete="$t('action.delete')" :batchDelete="$t('action.batchDelete')" :buttonOperation1="$t('action.showDetail')"
		@findPage="findPage" @handleEdit="handleEdit" @handleDelete="handleDelete" @handleOperation1="handleOperation1">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="100px" :rules="dataFormRules" ref="dataForm" :size="size">
      <el-form-item :label="$t('TAfoWaveDetail.whId')" prop="whId"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="dataForm.whId" auto-complete="off" disabled></el-input>
      </el-form-item>
			<el-form-item :label="$t('TAfoWaveDetail.waveId')" prop="waveId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.waveId" auto-complete="off" disabled></el-input>
			</el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.clientCode')" prop="clientCode"  v-if="!dataForm.isPrimaryKey">
        <el-select @change="getProfile" ref="clientCode" v-model="dataForm.clientCode" style="width:100%" required>
          <el-option v-for="(client,index) in this.clientData" :key="index" :value="client.clientCode"
                     :label="client.name"/>
        </el-select>
      </el-form-item>
			<el-form-item :label="$t('TAfoWaveDetail.profileId')" prop="profileId"  v-if="!dataForm.isPrimaryKey">
        <el-select @change="getProfilePara" ref="profileId" v-model="dataForm.profileId" style="width:100%" required>
          <el-option v-for="(profile,index) in this.profileData" :key="index" :value="profile.id"
                     :label="profile.profileDescrip"/>
        </el-select>
			</el-form-item>
			<el-form-item :label="$t('TAfoWaveDetail.parameters1')" prop="parameters1"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters1" auto-complete="off" disabled></el-input>
				<el-input v-model="dataForm.parameters1" auto-complete="off"></el-input>
			</el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters2')" prop="parameters2"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters2" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters2" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters3')" prop="parameters3"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters3" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters3" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters4')" prop="parameters4"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters4" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters4" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters5')" prop="parameters5"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters5" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters5" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters6')" prop="parameters6"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters6" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters6" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters7')" prop="parameters7"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters7" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters7" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters8')" prop="parameters8"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters8" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters8" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters9')" prop="parameters9"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters9" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters9" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TAfoWaveDetail.parameters10')" prop="parameters10"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="profilePara.parameters10" auto-complete="off" disabled></el-input>
        <el-input v-model="dataForm.parameters10" auto-complete="off"></el-input>
      </el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name: 'TAfoWaveDetail',
	components:{
			KtTable,
			KtButton
	},
	data() {
		return {
			size: 'small',
      clientData: Object,
      profileData: Object,
      filters: {
        waveId: '',
        whId: ''
      },
      profilePara: {
        parameters1: '',
        parameters2: '',
        parameters3: '',
        parameters4: '',
        parameters5: '',
        parameters6: '',
        parameters7: '',
        parameters8: '',
        parameters9: '',
        parameters10: ''
      },
			columns: [
				{prop:"id", label:"TAfoWaveDetail.id", minWidth:100},
        {prop:"whId", label:"TAfoWaveDetail.whId", minWidth:100},
				{prop:"waveId", label:"TAfoWaveDetail.waveId", minWidth:100},
				{prop:"orderNumber", label:"TAfoWaveDetail.orderNumber", minWidth:100},
				{prop:"loadSeq", label:"TAfoWaveDetail.loadSeq", minWidth:100},
			],
			pageRequest: { pageNum: 1, pageSize: 8 },
			pageResult: {},

			operation: false, // true:新增, false:编辑
			editDialogVisible: false, // 新增编辑界面是否显示
			editLoading: false,
			dataFormRules: {
				clientCode: [
					{ required: true, message: this.$t('TAfoWaveDetail.dataFormRules.clientCode'), trigger: 'blur' }
				],
        profileId: [
          { required: true, message: this.$t('TAfoWaveDetail.dataFormRules.profileId'), trigger: 'blur' }
        ]
			},
			// 新增编辑界面数据
			dataForm: {
        whId: null,
        clientCode: null,
        userName: null,
        profileId: null,
        waveId: null,
        loadId: null,
        parameters1: null,
        parameters2: null,
        parameters3: null,
        parameters4: null,
        parameters5: null,
        parameters6: null,
        parameters7: null,
        parameters8: null,
        parameters9: null,
        parameters10: null,
}
}
	},
	methods: {
    getParentParams: function () {
      if (this.$route.query.whId!=null && this.$route.query.waveId!=null){
        this.filters.whId=this.$route.query.whId
        this.filters.waveId=this.$route.query.waveId
      }
this.findPage(null)
    },
    //获取货主下拉列表
    getClient: function (){
      let objWhId = {whId:this.filters.whId}
      this.$wmsApi.globalOption.getClient(objWhId)
        .then(res =>
        {
          //请求返回的数据
          this.clientData = res.data
        })
    },
    //获取波次策略下拉列表
    getProfile: function (){
      let profileType = 'WAVE PROFILE'
      let whId = this.dataForm.whId
      let clientCode = this.dataForm.clientCode
      let objProfileType = {profileType:profileType,whId:whId,clientCode:clientCode}
      this.$wmsApi.tAfaProfile.getProfile(objProfileType)
        .then(res =>
        {
          //请求返回的数据
          this.profileData = res.data
        })
    },
    //获取波次策略参数
    getProfilePara: function (){
      let objProfile = {id:this.dataForm.profileId}
      this.$wmsApi.tAfaProfile.getProfilePara(objProfile)
        .then(res =>
        {
          //请求返回的数据
          if(JSON.stringify(res.data)==='[]')
          {
            this.$message({message: this.$t("TAfoWaveDetail.message.NotExistsProfile") + '', type: 'error'})
          }
else
          {
            let obj = res.data[0]
            this.profilePara.parameters1 = obj["parameters1"]
            this.profilePara.parameters2 = obj["parameters2"]
            this.profilePara.parameters3 = obj["parameters3"]
            this.profilePara.parameters4 = obj["parameters4"]
            this.profilePara.parameters5 = obj["parameters5"]
            this.profilePara.parameters6 = obj["parameters6"]
            this.profilePara.parameters7 = obj["parameters7"]
            this.profilePara.parameters8 = obj["parameters8"]
            this.profilePara.parameters9 = obj["parameters9"]
            this.profilePara.parameters10 = obj["parameters10"]
          }
        })
    },
		// 获取分页数据
		findPage: function (data) {
			if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			let whId=this.filters.whId
      let waveId=this.filters.waveId
      // let whId=this.$route.query.whId
      // let waveId=this.$route.query.waveId
      this.pageRequest.columnFilters = {whId:{name:'whId',value:whId},waveId:{name:'waveId',value:waveId}}
			this.$wmsApi.tAfoWaveDetail.findPage(this.pageRequest).then((res) => {
				this.pageResult = res.data
			}).then(data!=null?data.callback:'')
		},
		// 从波次移除订单（支持 ServiceResult 新格式和旧 ProcedureResult 格式）
		handleDelete: function (data) {
			this.$wmsApi.tAfoWaveDetail.removeOrder(data.params).then((res) => {
				if (res.code == 200 && res.data && res.data.code === 'SUCCESS') {
					this.$message({message: this.$t("common.message.success") + '', type: 'success'})
	}
else if (res.code == 200 && res.data) {
					this.$message({
						message: this.$t("common.message.fail") + (res.data.message ? ' ' + this.$t(res.data.message) : ''),
						type: 'error'
					})
	}
else {
					this.$message({message: this.$t("common.message.fail") + '', type: 'error'})
	}
this.findPage(null)
				if (data.callback) data.callback()
			})
		},
		// 显示新增界面
		handleAdd: function () {
			this.editDialogVisible = true
			this.operation = true
			// this.dataForm = {
      //   // whId: null,
			// 	// clientCode: null,
      //   profileId: null,
      //   waveId: null,
      //   loadId: null,
      //   parameters1: null,
      //   parameters2: null,
      //   parameters3: null,
      //   parameters4: null,
      //   parameters5: null,
      //   parameters6: null,
      //   parameters7: null,
      //   parameters8: null,
      //   parameters9: null,
      //   parameters10: null,
			// }
      this.dataForm.whId=this.filters.whId
      this.dataForm.waveId=this.filters.waveId
      this.getClient()
		},
		// 显示编辑界面
		handleEdit: function (params) {
			this.editDialogVisible = true
			this.operation = false
			this.dataForm = Object.assign({}, params.row)
		},
    // 显示明细界面
    handleOperation1: function (params) {
      this.$router.push({
        path: "/Wms/TAfoWaveDetailLine",
        query: {
          id: params.row.id,
          date:new Date().getTime()
        }
      })
    },
		// 编辑
		submitForm: function () {
			this.$refs.dataForm.validate((valid) => {
				if (valid) {
					this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {
						// let params = Object.assign({}, this.dataForm)
            this.dataForm.userName = sessionStorage.getItem('user')
            this.dataForm.localeId = sessionStorage.getItem('localeId')
						this.$wmsApi.tAfaProfile.execWaveLoadProfile(this.dataForm).then((res) => {
							if(res.code == 200) {
                let obj = res.data[0]
                let outCode = obj["outCode"]
                let outMsg = obj["outMsg"]

                if(outCode=='SUCCESS') {
                  let user = sessionStorage.getItem('user')
                  this.$router.push({
                    path: "/Wms/TAfaViewWaveOrder",
                    query: {
                      whId: this.dataForm.whId,
                      waveId: this.dataForm.waveId,
                      userName: user,
                      date: new Date().getTime()
                    }
                  })
                }
else{
                  this.$message({message: this.$t("common.message.fail") + outMsg, type: 'error'})
                }
				}
else {
								this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
				}
// this.$refs['dataForm'].resetFields()
							this.editDialogVisible = false
							// this.findPage(null)
              })
					})
	}
})
		},
		// 时间格式化
	dateFormat: function (row, column, cellValue, index){
    return format(row[column.property])
    }
	},
  activated() {
    this.getParentParams()
  },
	mounted() {
	}
}
</script>

<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TAfoWaveDetail.vue